var map = {
	"./industry-icon-automotive.svg": 7540,
	"./industry-icon-beauty.svg": 3516,
	"./industry-icon-clothing.svg": 2466,
	"./industry-icon-food.svg": 3427,
	"./industry-icon-health.svg": 4408,
	"./industry-icon-home.svg": 5056,
	"./industry-icon-industrial.svg": 8675,
	"./industry-icon-news.svg": 603,
	"./industry-icon-retailers.svg": 231,
	"./industry-icon-services.svg": 673,
	"./industry-icon-sports.svg": 2016,
	"./industry-icon-tech.svg": 2515,
	"./industry-icon-travel.svg": 4650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5485;